import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";

export const FormNumberField = ({ name, control, label, rules, defaultValue=0, ...other }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({
        field: { onChange, value },
        fieldState: { error },
        formState,
      }) => (
        <TextField
          required={rules && rules.required}
          style={{'marginTop': 20}}
          size="small"
          onChange={onChange}
          fullWidth
          label={label}
          variant="outlined"
          value={value}
          type="number"
          {...other}
        />
      )}
    />
  );
};